import { Pipe, PipeTransform, TemplateRef } from '@angular/core';

@Pipe({
  name: 'filterTableColByFeatFlag',
  standalone: true,
})
export class FilterTableColByFeatFlagPipe implements PipeTransform {
  transform<
    T extends {
      identifier?: string;
      template: TemplateRef<unknown>;
    },
  >(
    value: T[] | null | undefined,
    featFlagEnabled: boolean,
    columnIdentifier: string
  ): T[] {
    if (!value?.length) {
      return [];
    }

    if (featFlagEnabled) {
      return value;
    }

    return value.filter(item => item.identifier !== columnIdentifier);
  }
}
